import React, { useEffect } from 'react';
import NewAddress from './NewAddress';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default function DeliveryModal(props: any) {
    const addressData = useSelector((state: any) => state.customer.addressData);
    const isLogged = useSelector((state: any) => state.customer.isLogged);
    const propsPosition:any = useSelector((state: any) => state.payment.position);
    const propsSearchString = useSelector((state: any) => state.payment.searchString);
    const { changeLocation, setChangeLocation } = props;
    useEffect(() => {
        if (propsPosition) {
            props.setPosition(propsPosition)
            props.setLat(propsPosition.lat)
            props.setLng(propsPosition.lng)
            props.setSearchString(propsSearchString)
        }
    }, [])
    useEffect(() => {
        if (isLogged) {
            let defaultAddress = addressData.filter((obj: any) => { return obj.is_default == 1 });
            if (defaultAddress && defaultAddress.length > 0) {
                setTimeout(() => {
                    props.handleOnChange(defaultAddress[0])
                    props.setSaveAddressSelect(true)
                }, 1000)
            }
        }
    }, [])
    const handleValidTime = (event: { target: { name: any; value: any } }) => {
        props.setLaterDate(event.target.value)

        let validMinDateTime = new Date();
        validMinDateTime.setHours(validMinDateTime.getHours() + 1);
        let futureDate = moment(event.target.value).startOf('day')
        let currentDate = moment(new Date()).startOf('day');

        if (futureDate.isSame(currentDate)) {
            let futureDatetime = new Date(event.target.value)
            if (futureDatetime >= validMinDateTime) {
                props.setValidTimeFlag(true)
            } else {
                props.setValidTimeFlag(false)
            }
        } else {
            props.setValidTimeFlag(true)
        }

    }
    const handLeChangeLocation = () => {
        if (changeLocation && props.savedAddresses.length > 0) {
            props.setExtraDetails(props.selectedAddress.extra_details)
            props.setStreetName(props.selectedAddress.street_name)
            props.setStreetNumber(props.selectedAddress.street_number)
            props.setSearchString(props.selectedAddress.full_address)
            props.setLat(props.selectedAddress.lat)
            props.setLng(props.selectedAddress.lng)
            let data: any = {
                lat: props.selectedAddress.lat,
                lng: props.selectedAddress.lng
            }
            props.setPosition(data);
            setTimeout(() => {
                setChangeLocation(!changeLocation)
            }, 50);
        } else {
            let obj: any = {
                lat: 25.036467975147957,
                lng: 67.14281290769578
            };
            props.setPosition(null)
            props.setExtraDetails()
            props.setStreetName()
            props.setStreetNumber()
            props.setSearchString("")
            setTimeout(() => {
                setChangeLocation(!changeLocation)
            }, 50);
        }
        props.setConfirmAddress(false)
    }
    const handleMapData = (obj: any) => {
        // to Get the values from the map component and set in state
		// this.props.saveGuestAddress(obj.address);
        // props.setSearchString(obj.address)
        props.setLat(obj.lat)
        props.setLng(obj.lng)
        let data: any = {
            lat: obj.lat,
            lng: obj.lng
        }
        props.setPosition(data);
    };
    const handlePlace = (e: any) => {
        props.setPlace(e.target.value)
    }
    let todayDateTime = new Date();
    todayDateTime.setSeconds(0, 0);
    let m = moment(todayDateTime)

    //Today date
    let momentDate = m.format()
    let momentUpdate = momentDate.split("+")[0]
    let today = momentUpdate
    //Max Date
    let maxMomentDate = m.add(1, "days")
    let maxMomentDateUpdate = maxMomentDate.format().split("+")[0]
    let maxDate = maxMomentDateUpdate
    const token = localStorage.getItem("userToken");
    useEffect(() => {
        setChangeLocation(false)
    }, [])
    const { t } = useTranslation();
    return (
        <div>
            <div>
                {(token && props.savedAddresses && props.savedAddresses.length > 0) &&
                    <> <h5>{t("SAVEADDRESSES")}</h5>
                        <FormControl className='w-100 address-container'>
                            <RadioGroup
                                aria-labelledby="demo-radio-buttons-group-label"
                                name="radio-buttons-group"
                            >
                                {props.savedAddresses.map((obj: any, index: any) => {
                                    return (
                                        <div className='save-addresses'>
                                            <FormControlLabel checked={props.selectedAddress && props.selectedAddress.address_id == obj.address_id} control={<Radio className='color-theme' />} label={
                                                <>
                                                    <h5>{obj.place}</h5>
                                                    <h6>
                                                        {obj.street_name ? `${obj.street_name}, ` : null}
                                                        {obj.street_number ? `${obj.street_number}, ` : null}
                                                        {obj.extra_details ? `${obj.extra_details}, ` : null}
                                                        {obj.full_address ? `${obj.full_address}` : null}
                                                    </h6>
                                                </>
                                            } onClick={() => {
                                                props.setSaveAddressSelect(true)
                                                props.handleOnChange(obj)
                                            }} />
                                        </div>
                                    )
                                })}
                            </RadioGroup>
                        </FormControl>
                    </>
                }
                <NewAddress storesList={props.deliveryStoreList} setSaveAddressSelect={props.setSaveAddressSelect} handLeChangeLocation={handLeChangeLocation} changeLocation={changeLocation}
                    savedAddresses={props.savedAddresses} setSaveAddress={props.setSaveAddress}
                    saveAddressCheck={props.saveAddressCheck} handlePlace={handlePlace} place={props.place}
                    setExtraDetails={props.setExtraDetails} extra_details={props.extra_details} setStreetName={props.setStreetName} street_name={props.street_name} setStreetNumber={props.setStreetNumber} street_number={props.street_number}
                    position={props.position} handleMapData={handleMapData} setSearchString={props.setSearchString} searchString={props.searchString} setConfirmAddress={props.setConfirmAddress} confirmAdd={props.confirmAdd} propsPosition={propsPosition} />
            </div>
        </div>
    )
}
